import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Render a group of buttons or interactive elements inside a Card
 */
export default function CardActions({
  children,
  classes,
  elementRef,
  ...htmlAttributes
}) {
  return _jsx("div", {
    "data-component": "CardActions",
    ...htmlAttributes,
    className: classnames('flex items-center justify-end space-x-3', classes),
    ref: downcastRef(elementRef),
    children: children
  });
}
//# sourceMappingURL=CardActions.js.map